import EsusView from 'components/esus/EsusView'

export default function FichaComplementarView() {
  return <EsusView url='/pec/user/cds/fichaComplementar' />
}
